import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { createMerchantCategory, uploadCategoryImage } from "../api/categoriesApi";
import "css/add-product.css";
import { toast } from "react-toastify";

export default function AddCategoryModal({
  show,
  handleClose,
  parentId = null,
  onSaved,
}) {
  const defaultCategory = {
    name: "",
    rank: "",
    parentId,
  };

  const [category, setCategory] = useState(defaultCategory);
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleUpload = async (file, id) => {
    if (!file) return;
    const url = URL.createObjectURL(file);
    setImage({ file, url });
  };

  const openFileDialog = () => {
    document.getElementById("image-input").click();
  };

  const updateField = (field, value) => {
    setCategory((prev) => ({ ...prev, [field]: value }));
  };

  const submit = async () => {
    if (!image?.file) {
      toast.error("Зураг оруулна уу");
      return;
    }
    if (image.file.size > 500 * 1024) {
      toast.error("Зурагны хэмжээ 500KB-аас их байж болохгүй");
      return;
    }
    setLoading(true);
    try {
      const result = await createMerchantCategory(category);
      if (result.success) {
        const { id } = result.data;
        try {
          const res = await uploadCategoryImage(image.file, id);
          if (res.success) {
            toast.success("Ангилал амжилттай нэмэгдлээ");
            onSaved?.(); // modal хаагаад жагсаалтыг refetch (reload оронд)
          } else {
            toast.error("Зураг хуулах үед алдаа гарлаа");
          }
        } catch (error) {
          toast.error(error?.message || "Upload error");
        }
      }
    } catch (error) {
      toast.error(error?.message || "Ангилал үүсгэх үед алдаа гарлаа.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (parentId) {
      setCategory({
        name: "",
        rank: "",
        parentId,
      });
    }
    setImage(null);
  }, [parentId, show]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      onExited={() => {
        setCategory(defaultCategory);
        setImage(null);
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title>Ангилал нэмэх</Modal.Title>
      </Modal.Header>

      <Modal.Body className="px-4 pt-3 pb-4">
        {/* IMAGE UPLOAD AREA */}
        <div className="upload-area">
          {image || category.image ? (
            <div className="image-wrapper" onClick={openFileDialog}>
              <img src={image ? image.url : category.image} alt="category" />

              {/* EDIT BUTTON */}
              <div className="edit-btn">
                <i className="ri-pencil-fill"></i>
              </div>

              <input
                id="image-input"
                type="file"
                accept="image/jpeg"
                style={{ display: "none" }}
                onChange={(e) => handleUpload(e.target.files[0])}
              />
            </div>
          ) : (
            <div>
              <div
                className="upload-box"
                onClick={openFileDialog}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  cursor: "pointer",
                }}
              >
                <i className="uil uil-image" style={{ fontSize: 28 }}></i>
                <div>Зураг нэмэх</div>
              </div>

              <input
                id="image-input"
                type="file"
                accept="image/jpeg"
                style={{ display: "none" }}
                onChange={(e) => handleUpload(e.target.files[0])}
              />
            </div>
          )}
        </div>

        {/* FORM */}
        <div className="form-column-layout">
          <Form.Group className="my-3">
            <Form.Label>Ангиллын нэр</Form.Label>
            <Form.Control
              type="text"
              value={category.name}
              onChange={(e) => updateField("name", e.target.value)}
              placeholder="Жишээ: Гурил"
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Эрэмбэ</Form.Label>
            <Form.Control
              type="number"
              value={category.rank}
              onChange={(e) => updateField("rank", e.target.value)}
              placeholder="Жишээ: 1"
            />
          </Form.Group>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Хаах
        </Button>

        <Button variant="danger" onClick={submit}>
          {loading ? (
            <>
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              <span className="ms-2">Түр хүлээнэ үү...</span>
            </>
          ) : (
            "Хадгалах"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
